<template>
  <!-- 评分申请页面 -->
  <div class="vl-data-interface">
    <el-tabs v-model="tabName" @tab-click="tabSelect">
      <el-tab-pane label="已申请" name="1">
        <div class="tab-content">
          <div class="queryCondition">
            <el-select
              v-model="selectType"
              clearable
              placeholder="选择分类"
              style="width: 140px; margin-right: 10px"
            >
              <el-option
                v-for="item in typeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="status"
              clearable
              v-if="tabName === '1'"
              placeholder="选择审核状态"
              style="width: 140px; margin-right: 10px"
            >
              <el-option
                v-for="item in statusList"
                :key="item.status"
                :label="item.statusName"
                :value="item.status"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="indexName"
              clearable
              placeholder="请输入指标名称查询"
              style="width: 240px; margin-right: 10px"
              maxlength="30"
            ></el-input>
            <el-button type="primary" :loading="searchLoading" @click="getTableData"
            >查询</el-button
            >
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="indexTypeName"
              label="指标分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="indexName" label="指标名称"> </el-table-column>
            <el-table-column
              prop="indexDesc"
              label="指标说明"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="standardDataName"
              label="关联数据标准"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="standardDataCode"
              label="标准编码"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="审核状态"
              show-overflow-tooltip
              v-if="tabName === '1'"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == '0'">待审核</span>
                <span v-if="scope.row.status == '1'">已通过</span>
                <span v-if="scope.row.status == '2'">已取消</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="edit(scope.row)"
                  v-if="tabName === '1' && scope.row.status == '0'"
                >修改</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="cancel(scope.row)"
                  v-if="tabName === '1'"
                >取消</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="subApplication(scope.row)"
                  v-if="tabName === '2'"
                >申请</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="pagination.totalNum > 0 && tabName === '1'"
            background
            layout="prev, pager, next"
            :current-page.sync="pagination.pageNo"
            :total="pagination.totalNum"
            @current-change="handleCurrentChange"
            :page-size.sync="pagination.pageSize"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="未申请" name="2">
        <div class="queryCondition">
          <el-select
            v-model="selectType"
            clearable
            placeholder="选择分类"
            style="width: 140px; margin-right: 10px"
          >
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="status"
            clearable
            v-if="tabName === '1'"
            placeholder="选择审核状态"
            style="width: 140px; margin-right: 10px"
          >
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.statusName"
              :value="item.status"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="indexName"
            clearable
            placeholder="请输入指标名称查询"
            style="width: 240px; margin-right: 10px"
            maxlength="30"
          ></el-input>
          <el-button type="primary" :loading="searchLoading" @click="getTableData"
          >查询</el-button
          >
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="indexTypeName"
            label="指标分类"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="indexName" label="指标名称"> </el-table-column>
          <el-table-column
            prop="indexDesc"
            label="指标说明"
            min-width="180"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="standardDataName"
            label="关联数据标准"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="standardDataCode"
            label="标准编码"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="审核状态"
            show-overflow-tooltip
            v-if="tabName === '1'"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == '0'">待审核</span>
              <span v-if="scope.row.status == '1'">已通过</span>
              <span v-if="scope.row.status == '2'">已取消</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="edit(scope.row)"
                v-if="tabName === '1' && scope.row.status == '0'"
              >修改</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="cancel(scope.row)"
                v-if="tabName === '1'"
              >取消</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="subApplication(scope.row)"
                v-if="tabName === '2'"
              >申请</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="pagination.totalNum > 0 && tabName === '1'"
          background
          layout="prev, pager, next"
          :current-page.sync="pagination.pageNo"
          :total="pagination.totalNum"
          @current-change="handleCurrentChange"
          :page-size.sync="pagination.pageSize"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="达标操作记录" name="3">
        <filter-table
          :get-api="pageListAppIndexRecord"
          :filter-items="recordFilterItems"
          :ext-params="{appid: $route.query.appId}">
          <el-table-column label="指标名称" prop="indexName"></el-table-column>
          <el-table-column label="所属分类" prop="indexTypeName"></el-table-column>
          <el-table-column label="适用对象" prop="assignObjectName"></el-table-column>
          <el-table-column label="所属地区" prop="areaName" show-overflow-tooltip></el-table-column>
          <el-table-column label="学校" prop="schoolName" show-overflow-tooltip></el-table-column>
          <el-table-column label="老师" prop="userName"></el-table-column>
          <el-table-column label="操作日期" prop="operateDate"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="checkData(scope.row)">查看数据</el-button>
            </template>
          </el-table-column>
        </filter-table>
      </el-tab-pane>
      <el-tab-pane label="解析失败日志" name="4">
        <filter-table
          :get-api="pageListAppRecordLog"
          :filter-items="recordLogFilterItems"
          :ext-params="{appId: $route.query.appId}">
          <el-table-column label="标准名称" prop="standardDataName"></el-table-column>
          <el-table-column label="标准编码" prop="standardDataCode"></el-table-column>
          <el-table-column label="未达标类型" prop="codeName"></el-table-column>
          <el-table-column label="未达标信息" prop="message" show-overflow-tooltip></el-table-column>
          <el-table-column label="上传时间" prop="createTime"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="checkData(scope.row)">查看数据</el-button>
            </template>
          </el-table-column>
        </filter-table>
      </el-tab-pane>
    </el-tabs>

    <application-dialog
      :shwoApplicationDialog="shwoApplicationDialog"
      :editId="editId"
      :type="type"
      :indexObj="indexObj"
      @closeDialog="closeDialog"
    ></application-dialog>

    <el-dialog title="查看数据" :visible.sync="checkDataOpen" append-to-body width="800px">
      <el-form class="data-detail" label-width="85px">
        <el-form-item label="标准名称：">{{ checkDataRow.standardName }}</el-form-item>
        <el-form-item label="标准编码：">{{ checkDataRow.standardCode }}</el-form-item>
        <el-form-item label="应用ID：">{{ appDataInfo.appId }}</el-form-item>
        <el-form-item label="应用名：">{{ appDataInfo.appName }}</el-form-item>
        <el-form-item label="校验状态：">
          <span :style="{ color: checkDataRow.verifyState === '1' ? 'green' : 'red' }">
            {{ checkDataRow.verifyState === "1" ? "校验成功" : "校验失败" }}
          </span>
        </el-form-item>
        <el-form-item label="校验信息：">
          <span :style="{ color: checkDataRow.verifyState === '1' ? 'green' : 'red' }">
            {{ checkDataRow.verifyMessage }}
          </span>
        </el-form-item>
        <el-form-item label="上传时间：">{{ checkDataRow.dateTime }}</el-form-item>
        <el-form-item label="数据详情：">
          <div class="detail-item" v-for="(value, key) in parseJson(checkDataRow.dateJson)" :key="key">
            {{ key }}： {{ value }}
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import applicationDialog from "./applicationDialog.vue";
import FilterTable from "./FilterTable.vue";
import AreaSchoolSelect from "./AreaSchoolSelect.vue";
import DataRangePicker from "./DateRangePicker.vue";
import {
  dictList,
  selectAppApplyIndexList,
  selectAppNoApplyIndexList,
  cancelApplyIndex,
  submitApplyJudgeStandard,
  pageListAppIndexRecord,
  pageListAppRecordLog,
  getIndexList,
  getRecordLogCondition,
  getStandardDataById,
} from "@/views/index/api/personalCenter/api.personalCenter.js";
import { formatDateTime } from "@/utils/util";

const now = new Date();
const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
const endDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
const dateRangeTime = [formatDateTime(firstDay), formatDateTime(endDay)];

export default {
  props: {
    appDataInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabName: "1",
      selectType: null,
      typeList: [],
      status: null,
      statusList: [
        { status: 0, statusName: "待审核" },
        { status: 1, statusName: "已通过" },
        // { status: 2, statusName: "已取消" },
      ],
      indexName: "",
      searchLoading: false,
      tableData: [],
      pagination: {
        totalNum: 0,
        pageNo: 1,
        pageSize: 10,
      },
      shwoApplicationDialog: false,
      editId: null,
      indexObj: {},
      type: "add",
      pageListAppIndexRecord,
      pageListAppRecordLog,
      indexList: [],
      standardCodeList: [],
      errorTypeList: [],
      checkDataRow: {},
      checkDataOpen: false,
    };
  },
  components: {
    applicationDialog, FilterTable, AreaSchoolSelect, DataRangePicker
  },
  computed: {
    recordFilterItems() {
      return [
        { name: ["areaCode", "schoolId"], type: "custom", component: AreaSchoolSelect },
        { name: "indexId", type: "select", options: this.indexList, placeholder: "选择指标", width: 150 },
        { name: ["beginDate", "endDate"], defaultValue: dateRangeTime, type: "custom", component: DataRangePicker },
        { name: "userName", type: "input", placeholder: "输入老师姓名" },
      ];
    },
    recordLogFilterItems() {
      return [
        { name: "standardDataCode", type: "select", options: this.standardCodeList, placeholder: "选择标准名称", width: 130 },
        { name: "code", type: "select", options: this.errorTypeList, placeholder: "选择未达标类型", width: 150 },
        { name: ["beginDate", "endDate"], defaultValue: dateRangeTime, type: "custom", component: DataRangePicker },
        { name: "searchKey", type: "input", placeholder: "输入数据详情关键字", width: 225 },
      ];
    },
  },
  created() {
    this.getTypeList();
    this.getTableData();
    getIndexList().then((res) => {
      this.indexList = (res.result && res.result.list || []).map(item => ({ label: item.indexName, value: item.indexId }));
    });
    getRecordLogCondition().then((res) => {
      this.standardCodeList = res.result && res.result.standardCodeList || [];
      this.errorTypeList = res.result && res.result.errorTypeList || [];
    });
  },
  methods: {
    getTypeList() {
      dictList(88).then((res) => {
        if (res && res.result) {
          this.typeList = res.result;
        }
      });
    },
    tabSelect() {
      if (this.tabName === "1" || this.tabName === "2") {
        this.selectType = null;
        this.status = null;
        this.indexName = "";
        this.getTableData();
      }
    },
    // 编辑
    edit(v) {
      this.editId = v.indexId;
      this.type = "edit";
      this.indexObj = v;
      this.shwoApplicationDialog = true;
    },
    // 取消授权
    cancel(v) {
      this.$confirm(
        "<span style='font-size:16px;font-weight:bold'>确定要停止评分吗？</span><br/><span>停报后上报数据不进行评分，如需再次纳入评分需要重新提交申请，请慎重操作。</span>",
        "操作确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          cancelApplyIndex({
            appid: this.$route.query.appId,
            indexId: v.indexId,
          }).then((res) => {
            if (res && res.code === "00000") {
              this.$message.success("取消成功");
              this.getTableData();
            }
          });
        })
        .catch(() => {});
    },
    handleCurrentChange() {
      this.getAppliedTable();
    },
    getTableData() {
      this.pagination.pageNo = 1;
      if (this.tabName === "1") {
        this.getAppliedTable();
      } else {
        this.getNotAppliedTable();
      }
    },
    // 获取已申请列表
    getAppliedTable() {
      selectAppApplyIndexList({
        appid: this.$route.query.appId,
        indexTypeCode: this.selectType,
        status: this.status,
        indexName: this.indexName,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res && res.result) {
          this.tableData = res.result.list;
          this.pagination.totalNum = res.result.totalNum;
        }
      });
    },
    // 获取未申请列表
    getNotAppliedTable() {
      selectAppNoApplyIndexList({
        appid: this.$route.query.appId,
        indexTypeCode: this.selectType,
        indexName: this.indexName,
      }).then((res) => {
        if (res && res.result) {
          this.tableData = res.result;
        }
      });
    },
    // 提交申请
    subApplication(v) {
      submitApplyJudgeStandard({
        appid: this.$route.query.appId,
        indexId: v.indexId,
      }).then((res) => {
        if (res && res.code === "00000") {
          this.editId = v.indexId;
          this.type = "add";
          this.indexObj = v;
          this.shwoApplicationDialog = true;
        }
      });
    },
    closeDialog(v) {
      this.shwoApplicationDialog = false;
      if (v === "refresh") {
        this.getTableData();
      }
    },
    //数据数据
    checkData(row) {
      this.checkDataRow = {};
      this.checkDataOpen = true;
      getStandardDataById({ id: row.standardDataId, dataPeriod: row.createTime }).then(res => {
        if (res && res.result) {
          this.checkDataRow = res.result;
        }
      });
    },
    //Json转换
    parseJson(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return {};
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.vl-data-interface {
  .queryCondition {
    margin-bottom: 20px;
    position: relative;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    .search-right {
      position: absolute;
      right: 0px;
    }
  }
  /deep/.el-pagination {
    text-align: center;
    margin: 30px 0 50px;
  }
}

.data-detail ::v-deep .el-form-item {
  margin-bottom: 0!important;
}

.detail-item {
  padding-top: 12px;
  line-height: 1;
  &:last-child {
    margin-bottom: 20px;
  }
}
</style>
